module.exports = __webpack_public_path__ + "fonts/LatoLatin-Semibold.d120dac.woff";